import React, { useContext, useEffect, useState } from "react";
import { RotatingLines } from 'react-loader-spinner'
import AppBar from "../components/AppBar";
import { usBanks } from "../../../data/us-banks";
import  g20Countries  from "../../../data/g-20.json" 
import { Grid } from "@mui/material";
import {FirebaseContext} from "../../../context/firebase";
import { db } from "../../../lips/firebase_initialization";
import { runTransaction, doc, getDoc, updateDoc } from "firebase/firestore";
import EnterPinForInternationalTransaction from "../components/EnterPinForInternationalTransaction"



interface Props {
    handleBeneficiaryOpen: () => void
    handleBeneficiaryOpen2: () => void
    handleSelectAccountOpen: () => void
    transferActiveBeneficiary: string
    transferActiveBeneficiary2: string
    transferActiveBeneficiary3: string
    transferActiveBeneficiary4: string
    wrongAccountNumber: boolean
    networkError: boolean
    loading: boolean
    wrongAccountNumber2: boolean
    networkError2: boolean
    loading2: boolean,
    checkAccountNumber: () => void
    checkAccountNumber2: () => void
    handleECCUOption1: () => void
    handleOthersOption2: () => void
    handleOthersOption3: () => void
    setTransferProcessingActive: React.Dispatch<React.SetStateAction<boolean>>
    handleEnterPinForInternationTransactionOpen: () => void
    handleEnterPinForInternationTransactionClose: () => void
    lunchSomethingWrong: () => void
}




const Transfer: React.FC<Props>=({
    handleBeneficiaryOpen, 
    handleBeneficiaryOpen2,
    handleSelectAccountOpen,
    transferActiveBeneficiary, 
    transferActiveBeneficiary2,
    transferActiveBeneficiary3,
    transferActiveBeneficiary4,
    wrongAccountNumber,
    networkError,
    loading,
    wrongAccountNumber2,
    networkError2,
    loading2,
    checkAccountNumber,
    checkAccountNumber2,
    handleECCUOption1,
    handleOthersOption2,
    handleOthersOption3,
    setTransferProcessingActive,
    handleEnterPinForInternationTransactionOpen,
    handleEnterPinForInternationTransactionClose,
    lunchSomethingWrong

})=>{



      const { data, error, refresh, firebase } = useContext(FirebaseContext);
      const loginID = localStorage.getItem("loginID");

      const [btnActive, setBtnActive] = useState(true)
      const handleInputChange =(value: string) =>{
        if(value.length == 11){
            setBtnActive(false)
        }else{
            setBtnActive(true)
        }
      }

      const [selectBank, setSelectBank] = useState('')
      const [accountNumActive, setACcountNumActive] = useState(true)
      useEffect(()=>{
        if(selectBank != ''){
            setACcountNumActive(false)
        }else{
            setACcountNumActive(true)
        }
      }, [selectBank])

      useEffect(()=>{
        if(transferActiveBeneficiary != "Choose Beneficiary"){
            handleECCUOption1()
        }else if(transferActiveBeneficiary2 != "Choose Beneficiary"){
            handleOthersOption2()
        }else if(transferActiveBeneficiary3 != "Choose Beneficiary"){
            handleOthersOption3()
        }
      }, [])



      const [btnActive2, setBtnActive2] = useState(true)
      const handleInputChange2 =(value: string) =>{
        if(value.length >= 10){
            setBtnActive2(false)
        }else{
            setBtnActive2(true)
        }
      }



      const [naration, setNaration] = useState("")
      const [country, setCountry] = useState("")
      const [btnActive3, setBtnActive3] = useState(true)
      const [forward, setForward] = useState(false)

      const [transactionRecipiantName, setTransactionRecipiantName] = useState("")
      const [transactionIBAN, setTransactionIBAN] = useState("")
      const [transactionSwift, setTransactionSwift] = useState("")

      const [street, setStreet] = useState("")
      const [city, setCity] = useState("")
      const [postalCode, setPostalCode] = useState("")
      const [emailAddress, setEmailAddress] = useState("")
      const [amount, setAmount] = useState("")
      const [btnActive4, setBtnActive4] = useState(true)



      useEffect(()=>{
        if(naration && country){
            setBtnActive3(false)
        }else{
            setBtnActive3(true)
        }
      }, [naration, country])

      const handleProceedContinue =()=>{
        if(!btnActive3 && !forward){
            setForward(true)
            return
        }
      }



        const validateIBAN = (iban: string) => {
            const cleaned = iban.replace(/\s+/g, "").toUpperCase();
            const ibanRegex = /^[A-Z]{2}[0-9]{2}[A-Z0-9]{11,30}$/;
            return ibanRegex.test(cleaned);
        };
        const validateSWIFT = (swift: string) => {
            const cleaned = swift.replace(/\s+/g, "").toUpperCase();
            const swiftRegex = /^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/;
            return swiftRegex.test(cleaned);
        };
        // const validateAmount = (amount: string, balance: number) => {
        //     const num = Number(amount);
        //     if (isNaN(num)) return false;
        //     return num >= 100 && num <= balance;
        // };
        const validateAmount = (amount: any, balance: number) => {
          const num = Number(amount);
          if (isNaN(num) || num <= 0) throw new Error("Invalid amount");
          if (num > balance) throw new Error("Insufficient balance");
          return num;
        }; 
        const isAmountValidForUI = (amount: any, balance: number) => {
          const num = Number(amount);
          if (!amount) return false;
          if (isNaN(num) || num <= 0) return false;
          if (num > balance) return false;
          return true;
        };
        const getAmountError = (amount: any, balance: number): string | null => {
          const num = Number(amount);
          if (!amount) return "Enter an amount";
          if (isNaN(num) || num <= 0) return "Invalid amount";
          if (num > balance) return "Insufficient balance";
          return null;
        };
        useEffect(() => {
          const isIBANValid = validateIBAN(transactionIBAN);
          const isSWIFTValid = validateSWIFT(transactionSwift);
          const isAmountValid = isAmountValidForUI(amount, data.balanceInNumber);

          if (
            transactionRecipiantName &&
            isIBANValid &&
            isSWIFTValid &&
            street &&
            city &&
            postalCode &&
            emailAddress &&
            isAmountValid
          ) {
            setBtnActive4(false);
          } else {
            setBtnActive4(true);
          }
        }, [
          transactionRecipiantName,
          transactionIBAN,
          transactionSwift,
          street,
          city,
          postalCode,
          emailAddress,
          amount,
          data.balanceInNumber
        ]);








        function getUUID() {
            // eslint gets funny about bitwise
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
                const piece = (Math.random() * 16) | 0;
                const elem = c === 'x' ? piece : (piece & 0x3) | 0x8;
                return elem.toString(16);
            });
        }
        function getCurrentDateTime() {
            const now = new Date();

            const date = now.toISOString().split("T")[0];

            const time = now
                .toTimeString()
                .split(" ")[0];

            return { date, time };
        }
        function generateTransactionRef() {
            const now = new Date();

            // YYYYMMDD
            const date =
                now.getFullYear().toString() +
                String(now.getMonth() + 1).padStart(2, "0") +
                String(now.getDate()).padStart(2, "0");

            // Random 4-digit number
            const randomFour = Math.floor(1000 + Math.random() * 9000).toString();

            return `REF${date}${randomFour}`;
        }
        function formatNumberWithCommas(value: number): string {
            return value.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        }
        const generateTransactionId = () => crypto.randomUUID();
        const [formSubmitLoading, setformSubmitLoading] = useState<boolean>(false)
        const [submitFormError, setSubmitFormError] = useState<boolean>(false)

        const triggerInternationTransfer = async () => {
          setSubmitFormError(false);
          setformSubmitLoading(true);

          try {
            const documentId = localStorage.getItem("docId");
            if (!documentId) throw new Error("Account ID missing");

            const docRef = doc(db, "bank-application-data", documentId);

            await runTransaction(db, async (transaction) => {
              const snap = await transaction.get(docRef);
              if (!snap.exists()) throw new Error("Account not found");

              const data = snap.data();

              const transferAmount = validateAmount(
                amount,
                data.balanceInNumber
              );

              const newBalance = data.balanceInNumber - transferAmount;

              const formattedBalance = `$${newBalance.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}`;
              
            const transferId = generateTransactionId();
              // 🔹 Build International Transfer
              const internationalTransfer = {
                id: transferId,
                narration: naration,
                country,
                forward,
                transactionRecipiantName,
                transactionIBAN,
                transactionSwift,
                street,
                city,
                postalCode,
                emailAddress,
                amount: transferAmount,
                date: getCurrentDateTime().date,
                time: getCurrentDateTime().time,
                status: "Pending",
                type: "international-transfer"
              };

              // 🔹 Build Transaction Record
              const transactionRecord = {
                id: transferId,
                loginId: data.loginID,
                documentId: docRef,
                date: getCurrentDateTime().date,
                time: getCurrentDateTime().time,
                type: "debit",
                amount: formatNumberWithCommas(transferAmount),
                narration: naration,
                description: naration,
                method: "Wire Transfer",
                location: `${city}, ${country}`,
                status: "Pending",
                balance: formatNumberWithCommas(newBalance),
                transactionRef: generateTransactionRef()
              };

              // 🔹 Safe existing arrays
              const existingTransfers = Array.isArray(data.internationalTransfers)
                ? data.internationalTransfers
                : [];

              const existingTransactions = Array.isArray(data.transactions)
                ? data.transactions
                : [];

              // 🔹 ATOMIC UPDATE
              transaction.update(docRef, {
                balance: formattedBalance,
                balanceInNumber: newBalance,
                internationalTransfers: [...existingTransfers, internationalTransfer],
                transactions: [...existingTransactions, transactionRecord]
              });
            });

            setTransferProcessingActive(true);
            if (refresh) {
              setTimeout(() => refresh(), 3000);
            }

            setformSubmitLoading(false);

          } catch (err: any) {
            console.error(err);
            setformSubmitLoading(false);
            setSubmitFormError(true);
          }
        };
        const formSubmitHandler =()=>{
            handleEnterPinForInternationTransactionOpen()
        }  


    
    return (
        <>        
            <main id="content">
                <AppBar />

                <section className="container">

                    <div style={{padding: '3rem 0'}}>
                        <h1 className="tranfer-title-text">Send Money</h1>
                        <p className="tranfer-lead-text">Perform intrabank and interbank transfer operations here</p>


                        <div className="custom-tabs" style={{marginTop: '3rem', width: '100%'}}>
                            <ul role="tablist">
                                <li role="tab"><span onClick={handleECCUOption1} id="transfer-option-1" className="active">ECCU to ECCU</span></li>
                                <li role="tab"><span onClick={handleOthersOption2} id="transfer-option-2" className="">ECCU to Other Banks</span></li>
                                <li role="tab"><span onClick={handleOthersOption3} id="transfer-option-3" className="">International Transfer</span></li>
                            </ul>
                        </div>

                        <div id="groom-panel-active-option-1" className="groom-panel-2 active">
                            <div className="groom-panel-header"><p>Send Money to a ECCU user</p></div>

                            <div style={{paddingTop: '3rem'}}></div>

                            <div className="transfer-form">

                                <div className="transfer-form-row" style={{marginBottom: '1.6rem'}} onClick={handleBeneficiaryOpen}>
                                    <div className="col-md-12">
                                        <span className="select-beneficiary-button" role="button">{transferActiveBeneficiary}<img src="/imgs/nav-icons/sue2.svg" alt="" /></span>
                                    </div>
                                </div>


                                <div className="form-group" style={{marginBottom: '1.6rem'}}>
                                    <div className="transfer-form-row">
                                        <div className="col-md-12">
                                            <label>Recipient Account</label>
                                            <input name="recipientAccountNumber" type="text" className="form-control ft-recipient-input " maxLength={11} placeholder="Enter Account Number" autoCorrect="off" onChange={(e) => handleInputChange(e.currentTarget.value)}/>
                                        </div>

                                    </div>
                                </div>


                                <div style={{marginTop: '0.6rem', width: '100%'}}>
                                    <button className="btn create-acc ft-submit-btn" onClick={checkAccountNumber} disabled={btnActive}>Continue</button>

                                    {
                                        loading
                                        ?
                                        <RotatingLines
                                            visible={true}
                                            width="16"
                                            strokeWidth="5"
                                            animationDuration="0.75"
                                            ariaLabel="rotating-lines-loading"
                                        /> 
                                        :
                                        networkError
                                        ?
                                        <span style={{color: '#ff2e2e', fontSize: '0.8rem', fontStyle: 'italic'}}>Network error occurred</span>
                                        :
                                        wrongAccountNumber
                                        ?
                                        <span style={{color: '#ff2e2e', fontSize: '0.8rem', fontStyle: 'italic'}}>Unable to complete your request at the moment</span>
                                        :
                                        null
                                    }
                                </div>

                            </div>
     
                            <div style={{paddingTop: '3rem'}}></div>
                        </div>


                        <div id="groom-panel-active-option-2" className="groom-panel-2">
                            <div className="groom-panel-header"><p>Send Money to a Non-ECCU user</p></div>

                            <div style={{paddingTop: '3rem'}}></div>

                            <div className="transfer-form">

                                <div className="transfer-form-row" style={{marginBottom: '1.6rem'}} onClick={handleBeneficiaryOpen2}>
                                    <div className="col-md-12">
                                        <span className="select-beneficiary-button" role="button">{transferActiveBeneficiary2}<img src="/imgs/nav-icons/sue2.svg" alt="" /></span>
                                    </div>
                                </div>


                                <div className="form-group" style={{marginBottom: '1.6rem'}}>
                                    <div className="transfer-form-row">
                                        <div className="col-md-12">
                                            <label>Choose Bank</label>

                                            <select name="choosebank" id="" className="form-control ft-recipient-input" onChange={(e)=> setSelectBank(e.currentTarget.value)}>
                                                <option value=''>-- select bank --</option>
                                                {
                                                    usBanks.map((item: any, index: number)=>{
                                                    return (
                                                        <option value={item.name}>{item.name}</option>
                                                    )
                                                    })
                                                }
                                            </select>
                                        </div>

                                    </div>
                                </div>


                                <div className="form-group" style={{marginBottom: '1.6rem'}}>
                                    <div className="transfer-form-row">
                                        <div className="col-md-12">
                                            <label>Recipient Account</label>
                                            <input 
                                                name="recipientAccountNumber" 
                                                type="text" 
                                                className="form-control ft-recipient-input disable" 
                                                disabled={accountNumActive} placeholder="Enter Account Number" 
                                                autoCorrect="off" 
                                                style={accountNumActive ? {} :{backgroundColor: 'transparent', cursor: 'default'}} 
                                                onChange={(e) => handleInputChange2(e.currentTarget.value)}/>
                                        </div>

                                    </div>
                                </div>

                                
                                <div style={{marginTop: '0.6rem', width: '100%'}}>
                                    <button className="btn create-acc ft-submit-btn" onClick={checkAccountNumber2} disabled={btnActive2}>Continue</button>

                                    {
                                        loading2
                                        ?
                                        <RotatingLines
                                            visible={true}
                                            width="16"
                                            strokeWidth="5"
                                            animationDuration="0.75"
                                            ariaLabel="rotating-lines-loading"
                                        /> 
                                        :
                                        networkError2
                                        ?
                                        <span style={{color: '#ff2e2e', fontSize: '0.8rem', fontStyle: 'italic'}}>Network error occurred</span>
                                        :
                                        wrongAccountNumber2
                                        ?
                                        <span style={{color: '#ff2e2e', fontSize: '0.8rem', fontStyle: 'italic'}}>Unable to complete your request at the moment</span>
                                        :
                                        null
                                    }
                                </div>

                            </div>

                            <div style={{paddingTop: '3rem'}}></div>
                        </div>


                        <div id="groom-panel-active-option-3" className="groom-panel-2">
                            <div className="groom-panel-header"><p>International Wire Transfer</p></div>

                            <div style={{paddingTop: '3rem'}}></div>

                            <div className="transfer-form">

                                <div className="transfer-form-row" style={{marginBottom: '1.6rem'}} onClick={handleSelectAccountOpen}>
                                    <div className="col-md-12">
                                        <span className="select-beneficiary-button" role="button">{transferActiveBeneficiary4}<img src="/imgs/nav-icons/sue2.svg" alt="" /></span>
                                    </div>
                                </div>


                                <div className="form-group" style={{marginBottom: '1.6rem'}}>
                                    <div className="transfer-form-row">
                                        <div className="col-md-12">
                                            <label>Choose Country</label>

                                            <select name="choosebank" id="" className="form-control ft-recipient-input" disabled={forward} onChange={(e)=> setCountry(e.currentTarget.value)} required>
                                                <option value=''>-- select country --</option>
                                                {
                                                    g20Countries.map((item: any, index: number)=>{
                                                    return (
                                                        <option value={item.name}>{item.name}{item.flag}</option>
                                                    )
                                                    })
                                                }
                                            </select>
                                        </div>

                                    </div>
                                </div>


                                <div className="form-group" style={{marginBottom: '1.6rem'}}>
                                    <div className="transfer-form-row">
                                        <div className="col-md-12">
                                            <label>Narration</label>
                                            <input 
                                                name="transcation-naration-field" 
                                                type="text" 
                                                className="form-control ft-recipient-input disable" 
                                                placeholder="Purpose for this transaction" 
                                                autoCorrect="on" 
                                                disabled={forward}
                                                style={{backgroundColor: 'transparent', cursor: 'pointer'}} 
                                                value={naration}
                                                onChange={(e) => setNaration(e.currentTarget.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>



                                
                                {
                                    forward
                                    ? 
                                    <>
                                        <div className="form-group" style={{marginBottom: '1.6rem'}}>
                                            <div className="transfer-form-row">
                                                <div className="col-md-12">
                                                    <label>Recipient Name</label>
                                                    <input 
                                                        name="transcation-name-field" 
                                                        type="text" 
                                                        className="form-control ft-recipient-input disable" 
                                                        autoCorrect="on" 
                                                        style={{backgroundColor: 'transparent', cursor: 'default'}} 
                                                        value={transactionRecipiantName}
                                                        onChange={(e) => setTransactionRecipiantName(e.currentTarget.value)}
                                                        required    
                                                    />
                                                </div>
                                            </div>
                                        </div>


                                        <div className="form-group" style={{marginBottom: '1.6rem'}}>
                                            <div className="transfer-form-row">
                                                <div className="col-md-12">
                                                    <label>IBAN</label>
                                                    <input 
                                                        name="transcation-name-field" 
                                                        type="text" 
                                                        className="form-control ft-recipient-input disable" 
                                                        autoCorrect="on" 
                                                        style={{backgroundColor: 'transparent', cursor: 'default'}} 
                                                        value={transactionIBAN}
                                                        onChange={(e) => setTransactionIBAN(e.currentTarget.value)}
                                                        required
                                                    />
                                                    {transactionIBAN && !validateIBAN(transactionIBAN) && (
                                                        <small style={{ color: "red" }}>Invalid IBAN format</small>
                                                    )}

                                                </div>
                                            </div>
                                        </div>


                                        <div className="form-group" style={{marginBottom: '1.6rem'}}>
                                            <div className="transfer-form-row">
                                                <div className="col-md-12">
                                                    <label>SWIFT/BIC Code</label>
                                                    <input 
                                                        name="transcation-name-field" 
                                                        type="text" 
                                                        className="form-control ft-recipient-input disable" 
                                                        autoCorrect="on" 
                                                        style={{backgroundColor: 'transparent', cursor: 'default'}} 
                                                        value={transactionSwift}
                                                        onChange={(e) => setTransactionSwift(e.currentTarget.value)}
                                                        required
                                                    />
                                                    {transactionSwift && !validateSWIFT(transactionSwift) && (
                                                        <small style={{ color: "red" }}>Invalid SWIFT/BIC code</small>
                                                    )}
                                                </div>
                                            </div>
                                        </div>



                                        <section 
                                            style={{
                                                border: "1px solid #ccc",
                                                padding: "1rem",
                                                paddingTop: "2rem",
                                                borderRadius: "10px",
                                                marginBottom: "2rem",
                                                position: "relative"
                                            }}
                                            >
                                            {/* Header on border */}
                                            <span
                                                style={{
                                                position: "absolute",
                                                top: "-12px",
                                                left: "15px",
                                                background: "#fff",
                                                padding: "0 8px",
                                                fontSize: "0.9rem",
                                                fontWeight: "600",
                                                color: "#555"
                                                }}
                                            >
                                                Address
                                            </span>
                                             <div className="form-group" style={{marginBottom: '1.6rem'}}>
                                                    <div className="transfer-form-row">
                                                        <div className="col-md-12">
                                                            <label>Street</label>
                                                            <input 
                                                                name="transcation-street-field" 
                                                                type="text" 
                                                                className="form-control ft-recipient-input disable" 
                                                                autoCorrect="on" 
                                                                style={{backgroundColor: 'transparent', cursor: 'default'}} 
                                                                value={street}
                                                                onChange={(e) => setStreet(e.currentTarget.value)}
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                            </div>
                                            <Grid container>
                                                <Grid item xs={12} sm={4} md={4} lg={4}>
                                                    <div className="form-group" style={{marginBottom: '1.6rem'}}>
                                                        <div className="transfer-form-row">
                                                            <div className="col-md-12">
                                                                <label>Country</label>
                                                                <input 
                                                                    name="transcation-country-field" 
                                                                    type="text" 
                                                                    className="form-control ft-recipient-input disable" 
                                                                    autoCorrect="on" 
                                                                    style={{backgroundColor: 'transparent', cursor: 'default'}} 
                                                                    value={country}
                                                                    onChange={(e) => setCountry(e.currentTarget.value)}
                                                                    required
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Grid>
                                                <Grid item xs={12} sm={4} md={4} lg={4}>
                                                    <div className="form-group" style={{marginBottom: '1.6rem'}}>
                                                        <div className="transfer-form-row">
                                                            <div className="col-md-12">
                                                                <label>City</label>
                                                                <input 
                                                                    name="transcation-city-field" 
                                                                    type="text" 
                                                                    className="form-control ft-recipient-input disable" 
                                                                    autoCorrect="on" 
                                                                    style={{backgroundColor: 'transparent', cursor: 'default'}} 
                                                                    value={city}
                                                                    onChange={(e) => setCity(e.currentTarget.value)}
                                                                    required
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>                                                
                                                </Grid>
                                                <Grid item xs={12} sm={4} md={4} lg={4}>
                                                    <div className="form-group" style={{marginBottom: '1.6rem'}}>
                                                        <div className="transfer-form-row">
                                                            <div className="col-md-12">
                                                                <label>Postal Code</label>
                                                                <input 
                                                                    name="transcation-postal_code-field" 
                                                                    type="text" 
                                                                    className="form-control ft-recipient-input disable" 
                                                                    autoCorrect="on" 
                                                                    style={{backgroundColor: 'transparent', cursor: 'default'}} 
                                                                    value={postalCode}
                                                                    onChange={(e) => setPostalCode(e.currentTarget.value)}
                                                                    required
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>                                                
                                                </Grid>
                                            </Grid>
                                            <div className="form-group" style={{marginBottom: '1.6rem'}}>
                                                <div className="transfer-form-row">
                                                    <div className="col-md-12">
                                                        <label>Email Address</label>
                                                        <input 
                                                            name="transcation-email-field" 
                                                            type="email" 
                                                            className="form-control ft-recipient-input disable" 
                                                            autoCorrect="on" 
                                                            style={{backgroundColor: 'transparent', cursor: 'default'}} 
                                                            value={emailAddress}
                                                            onChange={(e) => setEmailAddress(e.currentTarget.value)}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </div>       
                                        </section>


                                        <div className="form-group" style={{marginBottom: '1.6rem'}}>
                                            <div className="transfer-form-row">
                                                <div className="col-md-12">
                                                    <label>Amount</label>
                                                    <input 
                                                        name="transcation-amount-field" 
                                                        type="number" 
                                                        className="form-control ft-recipient-input disable" 
                                                        autoCorrect="on" 
                                                        style={{backgroundColor: 'transparent', cursor: 'default'}} 
                                                        value={amount}
                                                        onChange={(e) => setAmount(e.currentTarget.value)}
                                                        required    
                                                    />
                                                </div>
                                                {amount && !validateAmount(amount, data.balanceInNumber) && (
                                                    <small style={{ color: "red" }}>
                                                        Amount must be at least $100 and cannot exceed {data.balance}.
                                                    </small>
                                                )}
                                            </div>
                                        </div> 
                                        
                                    </>
                                    :
                                    null
                                }
                                   

                                
                                <div style={{marginTop: '0.6rem', width: '100%'}}>
                                    {
                                        !forward
                                        ? 
                                        <button className="btn create-acc ft-submit-btn" disabled={btnActive3} onClick={()=> handleProceedContinue()}>Continue</button>
                                        :
                                        <>
                                            <button className="btn create-acc ft-submit-btn" disabled={btnActive4 || formSubmitLoading || data.accountLockDownStatus === 0} onClick={()=> formSubmitHandler()}>Proceed</button>
                                            
                                            {
                                                formSubmitLoading
                                                ?
                                                <RotatingLines
                                                    visible={true}
                                                    width="16"
                                                    strokeWidth="5"
                                                    animationDuration="0.75"
                                                    ariaLabel="rotating-lines-loading"
                                                /> 
                                                :
                                                submitFormError
                                                ?
                                                <span style={{color: '#ff2e2e', fontSize: '0.8rem', fontStyle: 'italic'}}>Network error occurred</span>
                                                :
                                                null
                                            }
                                        </>
                                        
                                    }
                                </div>

                            </div>

                            <div style={{paddingTop: '3rem'}}></div>
                        </div>
                    </div>


                </section>

            </main>


            <EnterPinForInternationalTransaction 
                handleEnterPinForInternationTransactionClose={handleEnterPinForInternationTransactionClose} 
                lunchSomethingWrong={lunchSomethingWrong}
                triggerInternationTransfer={triggerInternationTransfer}
                data={data}
            />

        </>
    )
}

export default Transfer